module.exports = __webpack_public_path__ + "static/media/error-file.844d4edf.svg";